import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const BrickmouldHeight = ({ value, onChange, label = 'Brickmould Height'}) => {
    const [selectedBrickmouldHeight, setSelectedBrickmouldHeight] = useState(value || "");
     const [BrickmouldHeightError, setBrickmouldHeightError] = useState("");


    useEffect(() => {
      }, []); // Trigger effect whenever doorSizeValue changes

    const handleBrickmouldHeightChange = (e) => {
        //setSelectedBrickmouldHeight(e.target.value);
        validateBrickmouldHeight(e.target.value);
        onChange(e.target.value);
    };
    const validateBrickmouldHeight = (value) => {
        const numericValue = value; //value.replace(/\D/g, ""); // Allow only numbers
        setSelectedBrickmouldHeight(numericValue);
        const element = document.getElementById('FrameHeight');
        let maxValue = 999;
        if (element) {
            maxValue = element.value;
        }
  
        if (numericValue && (numericValue < maxValue)) {
            setBrickmouldHeightError('Brickmould Height must be greater than or equal to ' + maxValue);
        } else {
            setBrickmouldHeightError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="BrickmouldHeight">{label}</label>
            <input style={{ display: "none" }}
                id="BrickmouldHeight"
                value={selectedBrickmouldHeight}
                onChange={handleBrickmouldHeightChange}
            >
            </input>
            {BrickmouldHeightError && <p className="error">{BrickmouldHeightError}</p>}
        </div>
    );
};

export default BrickmouldHeight;
